const balloonPaymentAtTheEndOfTheLoan = {
  conditionType: "any",
  hasValidation: false,
  validationType: "any",
  section: "agreement",
  subSection: "self",
  targetField: "balloonPaymentAtTheEndOfTheLoan",
  conditions: [
    {
      rule: "is_greater_than",
      ruleValue: "0",
      section: "loanDetails",
      subSection: "self",
      sourceField: "balloonAmount",
    },
  ],
  validations: [],
};

const idState = {
  conditionType: "any",
  hasValidation: false,
  validationType: "any",
  section: "customer",
  subSection: "self",
  targetField: "IDState",
  conditions: [
    {
      rule: "is_equal",
      ruleValue: "Licence",
      section: "customer",
      subSection: "self",
      sourceField: "IDType",
    },
  ],
  validations: [],
};

const idCountry = {
  conditionType: "any",
  hasValidation: false,
  validationType: "any",
  section: "customer",
  subSection: "self",
  targetField: "IDCountry",
  conditions: [
    {
      rule: "is_equal",
      ruleValue: "Passport",
      section: "customer",
      subSection: "self",
      sourceField: "IDType",
    },
  ],
  validations: [],
};

const landlordName = {
  conditionType: "any",
  hasValidation: false,
  validationType: "any",
  section: "customer",
  subSection: "customerProfile",
  targetField: "landlordName",
  conditions: [
    {
      rule: "is_equal",
      ruleValue: "Renting",
      section: "customer",
      subSection: "customerProfile",
      sourceField: "livingArrangements",
    },
  ],
  validations: [],
};

const expenseTypeRent = {
  conditionType: "any",
  hasValidation: true,
  validationType: "any",
  section: "customer",
  subSection: "expenses",
  targetField: "expensesType",
  conditions: [
    {
      rule: "is_equal",
      ruleValue: "Renting",
      section: "customer",
      subSection: "customerProfile",
      sourceField: "livingArrangements",
    },
  ],
  validations: [
    {
      rule: "is_equal",
      ruleValue: "Rent",
    },
  ],
  validationMessage: "An expense type of Rent is required",
};

const consumerConditionalFieldsTemplate = [
  balloonPaymentAtTheEndOfTheLoan,
  idState,
  idCountry,
  landlordName,
  expenseTypeRent,
];

const commercialConditionalFieldsTemplate = [idState, idCountry, landlordName];

export { consumerConditionalFieldsTemplate, commercialConditionalFieldsTemplate };
